import React, {useState, useContext, useEffect, useCallback} from 'react';
import {Popup, Input, toast, setOptions, Select, Checkbox, Button, SegmentedGroup, Segmented} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import '../styles/headerRegister.css';
import Loading from "../utils/Loading";
import CardToken from "../utils/CardToken";
import Empty from "../utils/Empty";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function HeaderRegister({locale, dialog, Dialog, registration, width, Configuration, setRegistration}) {
    const {restCall, restResponse, setRestResponse} = useContext(NetworkContext);
    const [registrationData, setRegistrationData] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [step, setStep] = useState(0);
    const [type, setType] = useState('mobile');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [country, setCountry] = useState(() => {
        if (window.localStorage.locale === 'en') {
            return 'us';
        } else if (window.localStorage.locale === 'es') {
            return 'mx';
        } else {
            return 'us';
        }
    });
    const [notifications, setNotifications] = useState(true);
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [stripe, setStripe] = useState({});
    const [account, setAccount] = useState(null);
    const [code, setCode] = useState(null);

    const DialogClose = () => {
        Dialog({view: 'close'});
    }

    const Registration = () => {
        toast({message: locale.headerRegister.ah, color: 'info', display: 'bottom', duration: 1000});

        const message = {
            type: 'rest',
            path: 'account-registration',
            action: 'get',
            data: {
                code: registration
            }
        };
        restCall(message);
    }

    const Header = () => {
        if (step === 0) {
            return locale.headerRegister.a;
        } else if (step === 1) {
            return locale.headerRegister.w;
        } else if (step === 2) {
            return locale.headerRegister.am;
        } else if (step === 3) {
            return locale.headerRegister.an;
        } else if (step === 4) {
            return locale.headerRegister.a;
        }
    }

    const AnchorCost = () => {
        const anchor = registrationData.cost.find(item => item.type === 'anchor');

        return anchor.cost;
    }

    const CheckPassword = () => {

        if (!password) {
            return true;
        }

        if (password.length < 8) {
            return false;
        }

        if (!/[A-Z]/.test(password)) {
            return false;
        }

        if (!/[a-z]/.test(password)) {
            return false;
        }

        if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
            return false;
        }

        return true;
    }

    const NextLabel = () => {
        if (step === 0) {
            return locale.headerRegister.b;
        } else if (step === 3) {
            return locale.headerRegister.ao;
        } else {
            return locale.headerRegister.u;
        }
    }

    const StepsLabel = () => {
        if (step === 0 && registrationData.type !== 'linked') {
            return locale.headerRegister.j;
        } else if (step === 1 && registrationData.type !== 'linked') {
            return locale.headerRegister.m;
        } else if (step === 2 && registrationData.type !== 'linked') {
            return locale.headerRegister.n;
        } else if (step === 3 && registrationData.type !== 'linked') {
            return locale.headerRegister.o;
        } else if (step === 0 && registrationData.type === 'linked') {
            return locale.headerRegister.p;
        } else if (step === 2 && registrationData.type === 'linked') {
            return locale.headerRegister.q;
        } else if (step === 3 && registrationData.type === 'linked') {
            return locale.headerRegister.r;
        }
    }

    const StepsProgress = () => {
        if (step === 0 && registrationData.type !== 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="2">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="3">
                </li>
            </ol>;
        } else if (step === 1 && registrationData.type !== 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="2">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="3">
                </li>
            </ol>;
        } else if (step === 2 && registrationData.type !== 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="2">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="3">
                </li>
            </ol>;
        } else if (step === 3 && registrationData.type !== 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="2">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="3">
                </li>
            </ol>;
        } else if (step === 0 && registrationData.type === 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="2">
                </li>
            </ol>;
        } else if (step === 2 && registrationData.type === 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-upcoming"
                    data-step="2">
                </li>
            </ol>;
        } else if (step === 3 && registrationData.type === 'linked') {
            return <ol className="cs-header-register-progress-track">
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="0">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-complete"
                    data-step="1">
                </li>
                <li className="cs-header-register-progress-dot cs-header-register-progress-dot-active"
                    data-step="2">
                </li>
            </ol>;
        }
    }

    const ClickCopy = () => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code);
            toast({message: locale.headerRegister.ax, color: 'info', duration: 1000, display: 'bottom'});
        } else {
            toast({message: locale.headerRegister.ay, color: 'danger', display: 'bottom', duration: 3000});
        }
    }

    const ButtonNext = () => {
        if (step === 0) {
            if (registrationData.type === 'linked') {
                setStep(2);
            } else {
                setStep(1);
            }
        } else if (step === 3) {
            setSaving(true);
            let user = null;
            if (registrationData.user && !Empty(registrationData.user)) {
                user = registrationData.user;
            } else if (!registrationData.user && registrationData.type !== 'linked') {
                user = {
                    firstName: firstName ? firstName : null,
                    lastName: lastName ? lastName : null,
                    type: type,
                    country: country,
                    mobile: mobile ? mobile.replace(/[()\s-]/g, '') : null,
                    email: email ? email : null,
                    password: password ? password : null,
                    notifications: notifications
                }
            }

            const message = {
                type: 'rest',
                path: 'account-activate',
                action: 'put',
                data: {
                    code: registration,
                    stripe: !Empty(stripe) ? stripe : null,
                    user: user
                }
            }
            restCall(message);
        } else {
            setStep(step + 1);
        }
    }

    const ButtonBack = () => {
        if (step === 3) {
            setStep(2);
        } else if (step === 2) {
            if (registrationData.type === 'linked') {
                setStep(0);
            } else {
                setStep(1);
            }
        } else if (step === 1) {
            setStep(0);
        }
    }

    const ButtonClose = () => {
        DialogClose();
    }

    const ButtonLogin = () => {
        Configuration(account);
        DialogClose();
    }

    const InputMobile = data => {
        let formattedText = '';

        if (country === 'us') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'mx') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 2) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'es') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 5) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3)}`;
            } else if (cleanedText.length <= 7) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5)}`;
            } else {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5, 7)} ${cleanedText.slice(7, 9)}`;
            }
        }
        setMobile(formattedText);
    }

    const SegmentedType = data => {

        setType(data.target.value);
    }

    const SelectCountry = data => {

        setCountry(data);
    }

    const ListItem = data => {
        const id = data.item.type;

        return <li data-id={id} className="cs-header-register-item-list-multi" >
            <div className="mbsc-row cs-header-register-item-list" >
                <div className="mbsc-col cs-header-register-item-list-item" >
                    <div>
                        <div className="mbsc-bold">
                            {data.item.type === 'anchor' &&
                                <span className="mbsc-txt-muted">{locale.headerRegister.bh.toUpperCase()}</span>
                            }
                            {data.item.type === 'tokens' &&
                                <span className="mbsc-txt-muted">{locale.headerRegister.bi.toUpperCase()}</span>
                            }
                            {data.item.type === 'tokens' && registrationData.billing.trial &&
                                <>
                                    &nbsp;&nbsp;&nbsp;
                                    <span className="mbsc-txt-s mbsc-txt-muted cs-header-register-item-list-text cs-header-register-helper-trial" >{locale.headerRegister.bj.toUpperCase()}</span>
                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="mbsc-col-auto cs-header-register-item-list-item" >
                    {data.item.type === 'anchor' && !registrationData.billing.trial &&
                        <div>
                            <span className="mbsc-bold">${data.item.cost.toFixed(2)}</span>&nbsp;&nbsp;<span className="mbsc-txt-muted mbsc-txt-s">{locale.headerRegister.bo}</span>
                        </div>
                    }
                    {data.item.type === 'anchor' && registrationData.billing.trial &&
                        <div>
                            <span className="mbsc-bold">{locale.headerRegister.bl}</span>&nbsp;&nbsp;<span className="mbsc-txt-muted mbsc-txt-s">{locale.headerRegister.bm}&nbsp;{registrationData.billing.trial}&nbsp;{locale.headerRegister.bn}</span>
                        </div>
                    }
                    {data.item.type === 'tokens' &&
                        <div>
                            <span className="mbsc-bold cs-header-register-helper-usage">{locale.headerRegister.bk}</span>
                        </div>
                    }
                </div>
            </div>
        </li>;
    }

    const NextDisabled = () => {
        if (step === 1 && !registrationData.user && !(password && confirm && password === confirm && CheckPassword() && firstName && lastName && ((registrationData.ui.login.mobile && mobile) || (registrationData.ui.login.email && email) || (registrationData.ui.login.multiple && type === 'mobile' && mobile) || (registrationData.ui.login.multiple && type === 'email' && email)))) {
            return true;
        }
        return false;
    }

    const GetAccountRegistration = useCallback(data => {
        if (data.registration) {
            setRegistrationData(data.registration);
            setCode(data.registration.code);
            if (!data.registration.user && data.registration.ui && data.registration.ui.login && data.registration.ui.login.mobile) {
                setType('mobile');
            } else if (!data.registration.user && data.registration.ui && data.registration.ui.login && data.registration.ui.login.email) {
                setType('email');
            }
            if (data.registration.user && !Empty(data.registration.user)) {
                setFirstName(data.registration.user.firstName ? data.registration.user.firstName : null);
                setLastName(data.registration.user.lastName ? data.registration.user.lastName : null);
                setType(data.registration.user.type ? data.registration.user.type : null);
                setMobile(data.registration.user.type === 'mobile' ? data.registration.user.id : null);
                setEmail(data.registration.user.type === 'email' ? data.registration.user.id : null)
            }
            setLoading(false);
        }
        if (data.account) {
            Configuration(data.account);
            Dialog({view: 'close'});
        }
        if (data.error && data.shortener) {
            toast({message: locale.headerRegister.ai, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.registration) {
            toast({message: locale.headerRegister.aj, color: 'danger', display: 'bottom', duration: 3000});
        }
    }, [locale.headerRegister.ai, locale.headerRegister.aj, Configuration, Dialog]);

    const PutAccountActivate = useCallback(data => {
        if (data.toast) {
            setStep(3);
            setRegistration(null);
        }
        if (data.account) {
            setAccount(data.account);
            window.localStorage.account = data.account;
        }
        if (data.error) {
            toast({message: locale.headerRegister.c, color: 'danger', display: 'bottom', duration: 3000});
        }
        setSaving(false);
    }, [locale.headerRegister.c]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'get' && restResponse.path === 'account-registration') {
            GetAccountRegistration(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, GetAccountRegistration, setRestResponse]);

    useEffect(() => {
        if (restResponse && !Empty(restResponse) && restResponse.action === 'put' && restResponse.path === 'account-activate') {
            PutAccountActivate(restResponse.data);
            setRestResponse({});
        }
    }, [restResponse, PutAccountActivate, setRestResponse]);

    useEffect(() => {
        Registration();
    }, []);

    return (
        <Popup className="cs-header-register-popup" width={600} maxHeight={750} closeOnOverlayClick={false}
               display="center" buttons={[]} isOpen={dialog.view === 'headerRegister'} onClose={DialogClose}>
            <div className="mbsc-grid cs-header-register-header-col">
                <div className="mbsc-row cs-header-register-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-header-register-header-col"/>
                    }
                    <div
                        className={width > 576 ? "mbsc-col cs-header-register-header-col mbsc-align-center" : "mbsc-col cs-header-register-header-col"}>
                        <Button className="cs-header-register-title-button mbsc-bold mbsc-txt-muted" variant="flat">
                            {Header()}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-header-register-header-col mbsc-align-right">
                        <Button disabled={step !== 0} color="primary" variant="flat"
                                className="mbsc-bold cs-header-register-close-button" onClick={() => ButtonClose()}>
                            &nbsp;<FontAwesomeIcon className="cs-header-register-close-icon" icon={faXmark}/>
                        </Button>
                    </div>
                </div>
            </div>
            {(saving || loading) &&
                <Loading/>
            }
            {!(saving || loading) && step !== 4 &&
                <>
                    {StepsProgress()}
                    <div className="mbsc-align-center mbsc-txt-muted mbsc-txt-s">
                        <p>{StepsLabel()}</p>
                    </div>
                </>
            }
            {!(saving || loading) && step === 0 &&
                <>
                    <div className="mbsc-align-center cs-header-register-helper-finish">
                        <p>{locale.headerRegister.g}</p>
                    </div>
                    <div className="mbsc-align-center cs-header-register-helper-finish">
                        <p><span className="mbsc-bold">{locale.headerRegister.h}:</span> {locale.headerRegister.i}</p>
                    </div>
                </>
            }
            {!(saving || loading) && step === 1 &&
                <>
                    <div className="cs-header-register-helper">
                        <p>{(registrationData.user && !Empty(registrationData.user)) ? locale.headerRegister.ag : locale.headerRegister.x}</p>
                    </div>
                    {registrationData.ui.login.multiple && !registrationData.user &&
                        <div className="mbsc-grid cs-header-register-header-col">
                            <div className="mbsc-row cs-header-register-header-row">
                                <SegmentedGroup className="cs-header-register-nav" name="userType" color="primary"
                                                value={type} onChange={SegmentedType}>
                                    <Segmented value="email">
                                        {locale.headerRegister.f}
                                    </Segmented>
                                    <Segmented value="mobile">
                                        {locale.headerRegister.e}
                                    </Segmented>
                                </SegmentedGroup>
                            </div>
                        </div>
                    }
                    {!registrationData.user && ((!registrationData.ui.login.multiple && registrationData.ui.login.mobile) || (registrationData.ui.login.multiple && type === 'mobile')) &&
                        <div className="mbsc-grid cs-header-register-header-col">
                            <div className="mbsc-row cs-header-register-header-row">
                                <div className="mbsc-col-4 cs-header-register-inputs-left">
                                    <Select
                                        animation="slide-down"
                                        dropdown={false}
                                        inputStyle="underline"
                                        label={locale.headerRegister.aa}
                                        labelStyle="floating"
                                        rows={locale.headerRegister.ab.length}
                                        display="anchored"
                                        touchUi={false}
                                        value={country}
                                        data={locale.headerRegister.ab}
                                        disabled={mobile}
                                        onChange={args => SelectCountry(args.value)}
                                    />
                                </div>
                                <div className="mbsc-col-8 cs-header-register-inputs-right">
                                    <Input
                                        className="cs-header-register-inputs-right-input"
                                        label={locale.headerRegister.e}
                                        inputStyle="underline"
                                        labelStyle="floating"
                                        type="text"
                                        name="mobile"
                                        value={mobile}
                                        disabled={registrationData.user && !Empty(registrationData.user)}
                                        onChange={ev => InputMobile(ev.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    }
                    {registrationData.user && type === 'mobile' &&
                        <Input
                            className="cs-header-register-inputs-right-input"
                            label={locale.headerRegister.e}
                            inputStyle="underline"
                            labelStyle="floating"
                            type="text"
                            name="mobile"
                            value={mobile}
                            disabled
                        />
                    }
                    {((!registrationData.ui.login.multiple && registrationData.ui.login.email) || (registrationData.ui.login.multiple && type === 'email')) &&
                        <Input disabled={registrationData.user && !Empty(registrationData.user)} inputStyle="underline" label={locale.headerRegister.f} labelStyle="floating" type="text" name="email" value={email} onChange={ev => setEmail(ev.target.value)}/>
                    }
                    <Checkbox
                        color="info"
                        label={locale.headerRegister.ac}
                        checked={notifications}
                        onChange={(ev) => setNotifications(ev.target.checked)}
                    />
                    <Input disabled={registrationData.user && !Empty(registrationData.user)} inputStyle="underline" label={locale.headerRegister.y} labelStyle="floating" type="text" name="firstName" value={firstName} onChange={ev => setFirstName(ev.target.value)}/>
                    <Input disabled={registrationData.user && !Empty(registrationData.user)} inputStyle="underline" label={locale.headerRegister.z} labelStyle="floating" type="text" name="lastName" value={lastName} onChange={ev => setLastName(ev.target.value)}/>
                    {!registrationData.user &&
                        <>
                            <Input error={!CheckPassword()} errorMessage={locale.headerRegister.bd} inputStyle="underline" label={locale.headerRegister.ad} labelStyle="floating" type="password" name="password" passwordToggle={true} value={password} onChange={(ev) => setPassword(ev.target.value)}/>
                            <Input error={confirm && password !== confirm} errorMessage={locale.headerRegister.be} inputStyle="underline" label={locale.headerRegister.ae} labelStyle="floating" type="password" name="confirm" passwordToggle={true} value={confirm} onChange={(ev) => setConfirm(ev.target.value)}/>
                        </>
                    }
                    {registrationData.user && !Empty(registrationData.user) &&
                        <div className="cs-header-register-helper">
                            <p>{locale.headerRegister.ar}</p>
                        </div>
                    }
                </>
            }
            {!(saving || loading) && step === 2 &&
                <>
                    <div className="cs-header-register-helper">
                        <p>
                            {locale.headerRegister.ap}
                        </p>
                    </div>
                    {registrationData.billing.trial &&
                        <div className="cs-header-register-helper cs-header-register-helper-discount">
                            <p>
                                {locale.headerRegister.aq}<span className="mbsc-bold">{registrationData.billing.trial}{locale.headerRegister.av}</span>{locale.headerRegister.as}
                            </p>
                        </div>
                    }
                    <Listview
                        theme="ios"
                        themeVariant="light"
                        select="single"
                        itemType={ListItem}
                        data={registrationData.cost}
                    />
                    {!registrationData.billing.trial &&
                        <div className="cs-header-register-helper cs-header-register-helper-billing">
                            <p>
                                {locale.headerRegister.bp}
                            </p>
                        </div>
                    }
                    {registrationData.billing.trial &&
                        <div className="cs-header-register-helper cs-header-register-helper-billing">
                            <p>
                                <span className="mbsc-bold">{locale.headerRegister.bq}</span>&nbsp;{locale.headerRegister.br}{AnchorCost()}&nbsp;{locale.headerRegister.bs}
                            </p>
                        </div>
                    }
                    {registrationData.billing.coupon &&
                        <div className="cs-header-register-helper cs-header-register-helper-coupon">
                            <p>
                                {locale.headerRegister.bt}
                            </p>
                        </div>
                    }
                    <div className="cs-header-register-helper">
                        <p>
                            {registrationData.stripe ? locale.headerRegister.s : locale.headerRegister.t}
                        </p>
                    </div>
                    {registrationData.stripe &&
                        <div className="cs-header-register-helper">
                            <p>
                                {locale.headerRegister.bf}
                            </p>
                        </div>
                    }
                    {!registrationData.stripe &&
                        <div className="cs-header-register-card">
                            <CardToken
                                textNext={locale.headerRegister.u}
                                Next={ButtonNext}
                                textBack={locale.headerRegister.v}
                                Back={ButtonBack}
                                setStripe={setStripe}
                            />
                        </div>
                    }
                </>
            }
            {!(saving || loading) && step === 3 &&
                <>
                    <div className="mbsc-align-center cs-header-register-helper-finish">
                        <p>
                            {locale.headerRegister.ak}
                        </p>
                    </div>
                    <div className="mbsc-align-center cs-header-register-helper-finish">
                        <p>{locale.headerRegister.af}&nbsp;<a className="cs-header-register-links" href="https://www.cubicstone.com/privacy-policy" target="_blank">{locale.headerRegister.ba}</a>&nbsp;{locale.headerRegister.bb}&nbsp;
                            <a className="cs-header-register-links" href="https://www.cubicstone.com/privacy-policy" target="_blank">{locale.headerRegister.bc}</a>
                        </p>
                    </div>
                    <div className="mbsc-align-center cs-header-register-helper-finish-end">
                        <p>
                            {locale.headerRegister.al}
                        </p>
                    </div>
                </>
            }
            {!(saving || loading) && step === 4 &&
                <>
                    <div className="cs-header-register-helper-finish">
                        <p>{locale.headerRegister.au}</p>
                    </div>
                    <ul>
                        <li key="1">
                            <div className="cs-header-register-helper-finish">
                                <p><span className="mbsc-bold">{locale.headerRegister.at}</span>&nbsp;{locale.headerRegister.k}</p>
                            </div>
                        </li>
                        <li key="2">
                            <div className="cs-header-register-helper-finish">
                                <p><span className="mbsc-bold">{locale.headerRegister.bu}</span>&nbsp;{locale.headerRegister.bv}</p>
                            </div>
                        </li>
                        <li key="3">
                            <div className="cs-header-register-helper-finish">
                                <p><span className="mbsc-bold">{locale.headerRegister.bw}</span>&nbsp;{locale.headerRegister.bx}</p>
                            </div>
                        </li>
                    </ul>
                    <div className="cs-header-register-helper-finish">
                        <p>{locale.headerRegister.bg}</p>
                    </div>
                    <div className="cs-header-register-helper-finish">
                        <p>{locale.headerRegister.az}</p>
                    </div>
                    <Input className="mbsc-txt-muted cs-header-register-helper-code" endIcon="copy2" inputStyle="underline" label={locale.headerRegister.l} labelStyle="floating" type="text" name="code" value={code} onClick={() => ClickCopy()}/>
                </>
            }
            {!(saving || loading) &&
                <div className="mbsc-button-group-justified cs-header-register-nav-buttons">
                    {step !== 0 && step !== 4 && (step !== 2 || (step === 2 && registrationData.stripe)) &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-header-register-nav-button" onClick={() => ButtonBack()}>
                            {locale.headerRegister.v}
                        </Button>
                    }
                    {step !== 4 && (step !== 2 || (step === 2 && registrationData.stripe)) &&
                        <Button disabled={NextDisabled()} color="primary" variant="flat" className="mbsc-bold cs-header-register-nav-button" onClick={() => ButtonNext()}>
                            {NextLabel()}
                        </Button>
                    }
                    {step === 4 &&
                        <Button color="primary" variant="flat" className="mbsc-bold cs-header-register-nav-button" onClick={() => ButtonLogin()}>
                            {locale.headerRegister.aw}
                        </Button>
                    }
                </div>
            }
        </Popup>
    );
}

export default HeaderRegister;
